import {take, put, select, fork} from 'redux-saga/effects';
import {persistenceStates} from '@computerrock/formation-core';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as communicationActionTypes from '../../communication/communicationActionTypes';
import config from '../../config';

const loadMemberMessages = function* loadMemberMessages({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const leaAssignmentFlowService = serviceManager.loadService('leaAssignmentFlowService');
    const {match} = payload;
    const {membershipNo} = match.params;

    const searchQueryParams = new URLSearchParams();
    searchQueryParams.append('page', 0);
    searchQueryParams.append('size', config.DEFAULT_PAGE_SIZE);
    searchQueryParams.append('contactId', membershipNo);

    yield fork(
        fetchRequest,
        communicationActionTypes.SEARCH_MEMBER_MESSAGES_REQUEST,
        leaAssignmentFlowService.getMessages,
        {searchQueryParams},
    );

    const responseAction = yield take([
        communicationActionTypes.SEARCH_MEMBER_MESSAGES_REQUEST_SUCCEEDED,
        communicationActionTypes.SEARCH_MEMBER_MESSAGES_REQUEST_FAILED,
    ]);

    yield put({
        type: communicationActionTypes.SET_MESSAGE_SEARCH_PERSISTENCE_STATE,
        payload: {newPersistenceState: persistenceStates.READY},
    });

    if (responseAction.error) {
        yield put({
            type: communicationActionTypes.STORE_MESSAGE_SEARCH_ERROR,
            payload: {isMessageSearchError: true},
        });
        return;
    }

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {messageDTOs, total} = response;

        yield put({
            type: communicationActionTypes.STORE_MESSAGE_SEARCH_RESULTS,
            payload: {
                pageNumber: 0,
                messagesSearchTotalCount: total,
                messageDTOs,
            },
        });

        yield put({
            type: communicationActionTypes.STORE_MESSAGE_SEARCH_ERROR,
            payload: {isMessageSearchError: false},
        });
    }
};

export default loadMemberMessages;
